import { render, staticRenderFns } from "./CanaryDashboard.vue?vue&type=template&id=7b8f0b38&scoped=true&"
import script from "./CanaryDashboard.vue?vue&type=script&lang=js&"
export * from "./CanaryDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CanaryDashboard.vue?vue&type=style&index=0&id=7b8f0b38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8f0b38",
  null
  
)

export default component.exports